import PropTypes from 'prop-types';

import { FormHeading } from 'twyne-new.ui';

import { ActiveForm } from '@/components/form/ActiveSwitch';

const propTypes = {
  data: PropTypes.any,
};

export default function MyProfileHeading({ active, onChangeActive }) {
  return <FormHeading
    goBack={false}
    title='My Profile'
  >
    <ActiveForm active={active} onChangeActive={onChangeActive} />
  </FormHeading>
}

MyProfileHeading.propTypes = propTypes
MyProfileHeading.defaultProps = {}
